
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as blogH4WnwLlLaLLC6bIaPNEh0mDAHsKPP0fz_NJumkUuFWoMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/blog.vue?macro=true";
import { default as aboutu1jRFYWa48ocpOaAXes6zYzX8iXHzZxphDNXmXxmWHMMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/about.vue?macro=true";
import { default as indexD97oeBdbwIBUEIsX_45MjwSd3L0YCuoJxsxEwyYWReImoMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/index.vue?macro=true";
import { default as eventsus4gUuI5eApdqATl5eAe_E1JpGe_45W77FlrJryBWzdbIMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/events.vue?macro=true";
import { default as contactdCMalwi_lPd5QAT9G_D_g_45L5dUdD1MxrPkyNgi3qFBoMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/contact.vue?macro=true";
import { default as coursespgcpjqZguN_45F9NlDXZ_45PrzhhdjE_3Ch2l9GMSenCc0MMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/courses.vue?macro=true";
import { default as welcome9iyWYihbrb20M7JwFeeiwPt2Zdp73i1Ugzr2HLSKpPwMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/welcome.vue?macro=true";
import { default as our_45workqsuzrGbo20dk_5Yeb7UwUsn1weAN6FN_45Hbo9kphCqKMMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/our-work.vue?macro=true";
import { default as platform9UDdNqLy_45dtTbeXAQy_uHDDSA6b6DEIUCaSF_456TOpUgMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/platform.vue?macro=true";
import { default as indexz_I5lYNzMU1OINHWNV9_45BxPh22fxvb_397Xqx3gPfGIMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/index.vue?macro=true";
import { default as profilerHRoM6ZBl8MP_TEFGiGMkn4aFr_s9wDb15wqi3xXzboMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/profile.vue?macro=true";
import { default as by_45levelvxBoz0yp13f2BlyepcysbsHlFNM_ZOE6vMylO3ozxQEMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/by-level.vue?macro=true";
import { default as magazineDrMfu6sTgcFp9rIehwvJAiDX6NvcJCBv_7xkj5gQE2kMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/magazine.vue?macro=true";
import { default as subscribeLJmGa_45wL4HoMgEgEA3XQfo3u49s2Riq0U3YJ4PBFSOkMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/subscribe.vue?macro=true";
import { default as subscriptionsOzw6NQXxhW3SePT57vEZFScjlG2GP6esLu1IoHhxBiEMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/subscriptions.vue?macro=true";
import { default as index7uFeje6syRQYyS51XrFQhSbOGcYHaVZYQf7GIy_klyYMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/blog/index.vue?macro=true";
import { default as play_45learnEw_LR6fsQIW9rpQvgjnLFFNWo6dzWfKNzAqUXaR1su0Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/play-learn.vue?macro=true";
import { default as _91portal_93I1XG4au_45YDlvp5JDH7wka_7wS4D2LQYgyEJjl56vKJkMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/login/[portal].vue?macro=true";
import { default as all_45contentrhLrf1uxlU5hXBV8vOkD_45tKt7iYrSUoUI3bcPbhMlcsMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/all-content.vue?macro=true";
import { default as leaderboardn1LXvbEzaC_45qt4VCWkWrK_45vkLKcs3K4Uu0cZekLciPgMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/leaderboard.vue?macro=true";
import { default as memberships0rK7dLQHo6NNU62dHh2WxnEcLuiGhDEx_45BINk5oFf_45wMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/memberships.vue?macro=true";
import { default as indexUTe2ZxlnJvL33uueVEk8pL03e8AaITLr2RUS2gi0ID8Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/video/index.vue?macro=true";
import { default as successFBlfAJK679Y5o4iRPteEkUNsT6kEzD5_1Fark_45JoBQIMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/payment/success.vue?macro=true";
import { default as _91slug_93gWXQcDWpPXpPHcnXatUOLKuqkNg5M9VeskeyUbi9LccMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/level/[slug].vue?macro=true";
import { default as premium_45packagesunFi2zTKkT5U1rQLwi8hDhgv_45ausD6sZhC2eUYLhVoAMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/premium-packages.vue?macro=true";
import { default as tournament_45entryZippWAswTrzXBbht84Uk56I3RT3AdcUtf_45NN0ejYq8YMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/tournament-entry.vue?macro=true";
import { default as tournamentsCvN_45MUH5E4OcNSdKbt7NtG_45aqIbKDnkb56m20rKmQc4Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/embed/tournaments.vue?macro=true";
import { default as club_45listingsqj7_45t4dQpRgWx3N6CuZLF4BrJMqPyP2jvzDJRyYUUroMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/club-listings.vue?macro=true";
import { default as index9ZAEzOuTCZ50WQJ_7QfQD9EEJaphFs5ELZVpKPcxbwkMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/gallery/index.vue?macro=true";
import { default as index1LBZBbFMikb1a6BLBQYsRSazF5lbNY1HE74NMZhVv2gMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium/index.vue?macro=true";
import { default as subscriptionsZwxVNgdifqfk4SXRyG_lGaHQ7rkHDS3nbBi8OQXxXg0Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/subscriptions.vue?macro=true";
import { default as indexoUxGBUJyyyA3ZvFv1W1RqjxTjfL2_45r41s9AWe8MALuoMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/chukkers/index.vue?macro=true";
import { default as _91slug_935SJZR7zORTshs_Rwm5WBOfLNmko3QlyUrIkDg3iG3JcMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/gallery/[slug].vue?macro=true";
import { default as nuxt_45error_45exampleRkyaD00d3YoyYaAoRSR8eQx5NsNqmsy1I4l7_45ExyqQQMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/nuxt-error-example.vue?macro=true";
import { default as _91postSlug_937JKnp2omE6CNwSW7vGfm6QI_45fj8b_45lHpZ2wzD4HGiyoMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/blog/[postSlug].vue?macro=true";
import { default as _91_46_46_46slug_93lNpqMTZtf9nM83PyVN7mEfBuu6E2ywJYcXdsBvcjNAYMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/pages/[...slug].vue?macro=true";
import { default as sentry_45example_45pageDPG50gfpZmPm50M7T2_45t0juZf0qZcLbnOxEfDBG2lPgMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/sentry-example-page.vue?macro=true";
import { default as premium_45packagesFXeMIt58_45w3PsXHP1j81bneRr8ebPp8fWNoMtCI0SXUMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium-packages.vue?macro=true";
import { default as performance_45analysisgC5ve4i_45zgQKbn_d0McKLPKUKq2DsRqKzKZQKEVvEBYMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/performance-analysis.vue?macro=true";
import { default as _91slug_93l5oaDtGpz1egST_Sd7p__45Rt_mtS2dZHKjE3B__45T0k6wMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/membership/[slug].vue?macro=true";
import { default as index4BkgtelxnDgMz0MzUHhfw9Ucrms44G4SKQ4pw0uiUDIMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/tournaments/index.vue?macro=true";
import { default as premium_45subscriptionsyfN31OQqFbpo6ECMkvUJ7f1Ii4_txIFMVpfcbl7PwzAMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/premium-subscriptions.vue?macro=true";
import { default as uspa_45post_45login_45actionj2NljM4_MseYO0t_454AuuFY9Jh_45Q5JHDuYJSpgzj7trgMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/uspa-post-login-action.js?macro=true";
import { default as indexF3iC03mNu_453D2_45r3s8aoR3QvprT_452nVtNUFQc9RX8toMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/contributors/index.vue?macro=true";
import { default as _91slug_93LJkZxizeHaI0BFHBVjg3_45Eu6luHZ7FEade2UdVTTQ_QMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/contributors/[slug].vue?macro=true";
import { default as _91slug_93C_kqXp3ZB6fJOT8_45odf3KoXCcY6mNCc7m1ZzLMeqJLAMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/blog/category/[slug].vue?macro=true";
import { default as _91bundleSlug_93WwCRvkXE2Cfv4COasEChjKlLNO7mpzljlfRpLM8aLF8Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium/[bundleSlug].vue?macro=true";
import { default as _91courseSlug_93ISnCbgBMTKYCivZa4_45Pe4xdAGFHXGftl3R5BXY5bd0EMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium/[courseSlug].vue?macro=true";
import { default as contributor_45contact0APaV2HJUBBx6xbpEz4_45F9BDb83AyCP3mlpIJTnCp_IMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/forms/contributor-contact.vue?macro=true";
import { default as international_45polo_45academy_fHM75z_45SXIYyemNhIFD8TbntdO38DzVbl1P2rIZPBEMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/international-polo-academy.vue?macro=true";
import { default as indexZAp3hmlwzTwMhYhkEjAM3ekqct9cpuLRuWp6vJr68MEMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/course-categories/index.vue?macro=true";
import { default as _91slug_931T_54Gj23xMg_45q3VZ_45W_ZNDIv1oVpPDszuq0cv5X8ToMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/course-categories/[slug].vue?macro=true";
import { default as index3VaL2gQB7HgnOw68nR77eVx8RVezxsMcTy1sYhp5w68Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/courses/[courseSlug]/index.vue?macro=true";
import { default as _91_91videoSlug_93_93XhPDXXihl6WAywpryPCdN08aXngUv18E9t4RFwPyEyMMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/video/[slug]/[[videoSlug]].vue?macro=true";
import { default as indexxJ0wVGI0Bsu41g12bHZDIpkfnOMVpn2B0pHKU_ZNYAwMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium-subscriptions/index.vue?macro=true";
import { default as bundlesTy1LcUHXf9pd33y9S9u0Qp1SlmsG96j5JEK4y_45Es20cMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/courses/[courseSlug]/bundles.vue?macro=true";
import { default as _91lessonSlug_93SGQ_OR5YyleMvxDn2wLkCBabaYBhtS_45_CTRg6wB9FM4Meta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/courses/[courseSlug]/[lessonSlug].vue?macro=true";
import { default as _91courseSlug_93_UXi1PvGUHM07QGcmylNOM2JlCkl_B3aChQKbZNMB7gMeta } from "C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium-subscriptions/[courseSlug].vue?macro=true";
export default [
  {
    name: blogH4WnwLlLaLLC6bIaPNEh0mDAHsKPP0fz_NJumkUuFWoMeta?.name ?? "blog",
    path: "/blog",
    meta: blogH4WnwLlLaLLC6bIaPNEh0mDAHsKPP0fz_NJumkUuFWoMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/blog.vue")
  },
  {
    name: aboutu1jRFYWa48ocpOaAXes6zYzX8iXHzZxphDNXmXxmWHMMeta?.name ?? "about",
    path: "/about",
    meta: aboutu1jRFYWa48ocpOaAXes6zYzX8iXHzZxphDNXmXxmWHMMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/about.vue")
  },
  {
    name: indexD97oeBdbwIBUEIsX_45MjwSd3L0YCuoJxsxEwyYWReImoMeta?.name ?? "index",
    path: "/",
    meta: indexD97oeBdbwIBUEIsX_45MjwSd3L0YCuoJxsxEwyYWReImoMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/index.vue")
  },
  {
    name: eventsus4gUuI5eApdqATl5eAe_E1JpGe_45W77FlrJryBWzdbIMeta?.name ?? "events",
    path: "/events",
    meta: eventsus4gUuI5eApdqATl5eAe_E1JpGe_45W77FlrJryBWzdbIMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/events.vue")
  },
  {
    name: contactdCMalwi_lPd5QAT9G_D_g_45L5dUdD1MxrPkyNgi3qFBoMeta?.name ?? "contact",
    path: "/contact",
    meta: contactdCMalwi_lPd5QAT9G_D_g_45L5dUdD1MxrPkyNgi3qFBoMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/contact.vue")
  },
  {
    name: coursespgcpjqZguN_45F9NlDXZ_45PrzhhdjE_3Ch2l9GMSenCc0MMeta?.name ?? "courses",
    path: "/courses",
    meta: coursespgcpjqZguN_45F9NlDXZ_45PrzhhdjE_3Ch2l9GMSenCc0MMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/courses.vue")
  },
  {
    name: welcome9iyWYihbrb20M7JwFeeiwPt2Zdp73i1Ugzr2HLSKpPwMeta?.name ?? "welcome",
    path: "/welcome",
    meta: welcome9iyWYihbrb20M7JwFeeiwPt2Zdp73i1Ugzr2HLSKpPwMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/welcome.vue")
  },
  {
    name: our_45workqsuzrGbo20dk_5Yeb7UwUsn1weAN6FN_45Hbo9kphCqKMMeta?.name ?? "our-work",
    path: "/our-work",
    meta: our_45workqsuzrGbo20dk_5Yeb7UwUsn1weAN6FN_45Hbo9kphCqKMMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/our-work.vue")
  },
  {
    name: platform9UDdNqLy_45dtTbeXAQy_uHDDSA6b6DEIUCaSF_456TOpUgMeta?.name ?? "platform",
    path: "/platform",
    meta: platform9UDdNqLy_45dtTbeXAQy_uHDDSA6b6DEIUCaSF_456TOpUgMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/platform.vue")
  },
  {
    name: indexz_I5lYNzMU1OINHWNV9_45BxPh22fxvb_397Xqx3gPfGIMeta?.name ?? "lms",
    path: "/lms",
    meta: indexz_I5lYNzMU1OINHWNV9_45BxPh22fxvb_397Xqx3gPfGIMeta || {},
    alias: ["/"],
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/index.vue")
  },
  {
    name: profilerHRoM6ZBl8MP_TEFGiGMkn4aFr_s9wDb15wqi3xXzboMeta?.name ?? "lms-profile",
    path: "/lms/profile",
    meta: profilerHRoM6ZBl8MP_TEFGiGMkn4aFr_s9wDb15wqi3xXzboMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/profile.vue")
  },
  {
    name: by_45levelvxBoz0yp13f2BlyepcysbsHlFNM_ZOE6vMylO3ozxQEMeta?.name ?? "lms-by-level",
    path: "/lms/by-level",
    meta: by_45levelvxBoz0yp13f2BlyepcysbsHlFNM_ZOE6vMylO3ozxQEMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/by-level.vue")
  },
  {
    name: magazineDrMfu6sTgcFp9rIehwvJAiDX6NvcJCBv_7xkj5gQE2kMeta?.name ?? "lms-magazine",
    path: "/lms/magazine",
    meta: { ...(magazineDrMfu6sTgcFp9rIehwvJAiDX6NvcJCBv_7xkj5gQE2kMeta || {}), ...{"middleware":["staging-only"]} },
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/magazine.vue")
  },
  {
    name: subscribeLJmGa_45wL4HoMgEgEA3XQfo3u49s2Riq0U3YJ4PBFSOkMeta?.name ?? "lms-subscribe",
    path: "/lms/subscribe",
    meta: subscribeLJmGa_45wL4HoMgEgEA3XQfo3u49s2Riq0U3YJ4PBFSOkMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/subscribe.vue")
  },
  {
    name: subscriptionsOzw6NQXxhW3SePT57vEZFScjlG2GP6esLu1IoHhxBiEMeta?.name ?? "subscriptions",
    path: "/subscriptions",
    meta: subscriptionsOzw6NQXxhW3SePT57vEZFScjlG2GP6esLu1IoHhxBiEMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/subscriptions.vue")
  },
  {
    name: index7uFeje6syRQYyS51XrFQhSbOGcYHaVZYQf7GIy_klyYMeta?.name ?? "lms-blog",
    path: "/lms/blog",
    meta: index7uFeje6syRQYyS51XrFQhSbOGcYHaVZYQf7GIy_klyYMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/blog/index.vue")
  },
  {
    name: play_45learnEw_LR6fsQIW9rpQvgjnLFFNWo6dzWfKNzAqUXaR1su0Meta?.name ?? "lms-play-learn",
    path: "/lms/play-learn",
    meta: play_45learnEw_LR6fsQIW9rpQvgjnLFFNWo6dzWfKNzAqUXaR1su0Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/play-learn.vue")
  },
  {
    name: _91portal_93I1XG4au_45YDlvp5JDH7wka_7wS4D2LQYgyEJjl56vKJkMeta?.name ?? "login-portal",
    path: "/login/:portal()",
    meta: _91portal_93I1XG4au_45YDlvp5JDH7wka_7wS4D2LQYgyEJjl56vKJkMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/login/[portal].vue")
  },
  {
    name: all_45contentrhLrf1uxlU5hXBV8vOkD_45tKt7iYrSUoUI3bcPbhMlcsMeta?.name ?? "lms-all-content",
    path: "/lms/all-content",
    meta: all_45contentrhLrf1uxlU5hXBV8vOkD_45tKt7iYrSUoUI3bcPbhMlcsMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/all-content.vue")
  },
  {
    name: leaderboardn1LXvbEzaC_45qt4VCWkWrK_45vkLKcs3K4Uu0cZekLciPgMeta?.name ?? "lms-leaderboard",
    path: "/lms/leaderboard",
    meta: { ...(leaderboardn1LXvbEzaC_45qt4VCWkWrK_45vkLKcs3K4Uu0cZekLciPgMeta || {}), ...{"middleware":["leaderboard-guard"]} },
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/leaderboard.vue")
  },
  {
    name: memberships0rK7dLQHo6NNU62dHh2WxnEcLuiGhDEx_45BINk5oFf_45wMeta?.name ?? "lms-memberships",
    path: "/lms/memberships",
    meta: memberships0rK7dLQHo6NNU62dHh2WxnEcLuiGhDEx_45BINk5oFf_45wMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/memberships.vue")
  },
  {
    name: indexUTe2ZxlnJvL33uueVEk8pL03e8AaITLr2RUS2gi0ID8Meta?.name ?? "lms-video",
    path: "/lms/video",
    meta: indexUTe2ZxlnJvL33uueVEk8pL03e8AaITLr2RUS2gi0ID8Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/video/index.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/payment/success.vue")
  },
  {
    name: _91slug_93gWXQcDWpPXpPHcnXatUOLKuqkNg5M9VeskeyUbi9LccMeta?.name ?? "lms-level-slug",
    path: "/lms/level/:slug()",
    meta: _91slug_93gWXQcDWpPXpPHcnXatUOLKuqkNg5M9VeskeyUbi9LccMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/level/[slug].vue")
  },
  {
    name: premium_45packagesunFi2zTKkT5U1rQLwi8hDhgv_45ausD6sZhC2eUYLhVoAMeta?.name ?? "premium-packages",
    path: "/premium-packages",
    meta: premium_45packagesunFi2zTKkT5U1rQLwi8hDhgv_45ausD6sZhC2eUYLhVoAMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/premium-packages.vue")
  },
  {
    name: "tournament-entry",
    path: "/tournament-entry",
    meta: tournament_45entryZippWAswTrzXBbht84Uk56I3RT3AdcUtf_45NN0ejYq8YMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/tournament-entry.vue")
  },
  {
    name: "embed-tournaments",
    path: "/embed/tournaments",
    meta: tournamentsCvN_45MUH5E4OcNSdKbt7NtG_45aqIbKDnkb56m20rKmQc4Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/embed/tournaments.vue")
  },
  {
    name: club_45listingsqj7_45t4dQpRgWx3N6CuZLF4BrJMqPyP2jvzDJRyYUUroMeta?.name ?? "lms-club-listings",
    path: "/lms/club-listings",
    meta: club_45listingsqj7_45t4dQpRgWx3N6CuZLF4BrJMqPyP2jvzDJRyYUUroMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/club-listings.vue")
  },
  {
    name: index9ZAEzOuTCZ50WQJ_7QfQD9EEJaphFs5ELZVpKPcxbwkMeta?.name ?? "lms-gallery",
    path: "/lms/gallery",
    meta: { ...(index9ZAEzOuTCZ50WQJ_7QfQD9EEJaphFs5ELZVpKPcxbwkMeta || {}), ...{"middleware":["gallery-guard"]} },
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/gallery/index.vue")
  },
  {
    name: index1LBZBbFMikb1a6BLBQYsRSazF5lbNY1HE74NMZhVv2gMeta?.name ?? "lms-premium",
    path: "/lms/premium",
    meta: index1LBZBbFMikb1a6BLBQYsRSazF5lbNY1HE74NMZhVv2gMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium/index.vue")
  },
  {
    name: subscriptionsZwxVNgdifqfk4SXRyG_lGaHQ7rkHDS3nbBi8OQXxXg0Meta?.name ?? "lms-subscriptions",
    path: "/lms/subscriptions",
    meta: subscriptionsZwxVNgdifqfk4SXRyG_lGaHQ7rkHDS3nbBi8OQXxXg0Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/subscriptions.vue")
  },
  {
    name: indexoUxGBUJyyyA3ZvFv1W1RqjxTjfL2_45r41s9AWe8MALuoMeta?.name ?? "lms-chukkers",
    path: "/lms/chukkers",
    meta: { ...(indexoUxGBUJyyyA3ZvFv1W1RqjxTjfL2_45r41s9AWe8MALuoMeta || {}), ...{"middleware":["chukkers-guard"]} },
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/chukkers/index.vue")
  },
  {
    name: _91slug_935SJZR7zORTshs_Rwm5WBOfLNmko3QlyUrIkDg3iG3JcMeta?.name ?? "lms-gallery-slug",
    path: "/lms/gallery/:slug()",
    meta: { ...(_91slug_935SJZR7zORTshs_Rwm5WBOfLNmko3QlyUrIkDg3iG3JcMeta || {}), ...{"middleware":["gallery-guard"]} },
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/gallery/[slug].vue")
  },
  {
    name: "nuxt-error-example",
    path: "/nuxt-error-example",
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/nuxt-error-example.vue")
  },
  {
    name: _91postSlug_937JKnp2omE6CNwSW7vGfm6QI_45fj8b_45lHpZ2wzD4HGiyoMeta?.name ?? "lms-blog-postSlug",
    path: "/lms/blog/:postSlug()",
    meta: _91postSlug_937JKnp2omE6CNwSW7vGfm6QI_45fj8b_45lHpZ2wzD4HGiyoMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/blog/[postSlug].vue")
  },
  {
    name: _91_46_46_46slug_93lNpqMTZtf9nM83PyVN7mEfBuu6E2ywJYcXdsBvcjNAYMeta?.name ?? "lms-pages-slug",
    path: "/lms/pages/:slug(.*)*",
    meta: _91_46_46_46slug_93lNpqMTZtf9nM83PyVN7mEfBuu6E2ywJYcXdsBvcjNAYMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/pages/[...slug].vue")
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/sentry-example-page.vue")
  },
  {
    name: premium_45packagesFXeMIt58_45w3PsXHP1j81bneRr8ebPp8fWNoMtCI0SXUMeta?.name ?? "lms-premium-packages",
    path: "/lms/premium-packages",
    meta: premium_45packagesFXeMIt58_45w3PsXHP1j81bneRr8ebPp8fWNoMtCI0SXUMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium-packages.vue")
  },
  {
    name: performance_45analysisgC5ve4i_45zgQKbn_d0McKLPKUKq2DsRqKzKZQKEVvEBYMeta?.name ?? "performance-analysis",
    path: "/performance-analysis",
    meta: performance_45analysisgC5ve4i_45zgQKbn_d0McKLPKUKq2DsRqKzKZQKEVvEBYMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/performance-analysis.vue")
  },
  {
    name: _91slug_93l5oaDtGpz1egST_Sd7p__45Rt_mtS2dZHKjE3B__45T0k6wMeta?.name ?? "lms-membership-slug",
    path: "/lms/membership/:slug()",
    meta: _91slug_93l5oaDtGpz1egST_Sd7p__45Rt_mtS2dZHKjE3B__45T0k6wMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/membership/[slug].vue")
  },
  {
    name: index4BkgtelxnDgMz0MzUHhfw9Ucrms44G4SKQ4pw0uiUDIMeta?.name ?? "lms-tournaments",
    path: "/lms/tournaments",
    meta: { ...(index4BkgtelxnDgMz0MzUHhfw9Ucrms44G4SKQ4pw0uiUDIMeta || {}), ...{"middleware":["tournaments-guard"]} },
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/tournaments/index.vue")
  },
  {
    name: premium_45subscriptionsyfN31OQqFbpo6ECMkvUJ7f1Ii4_txIFMVpfcbl7PwzAMeta?.name ?? "premium-subscriptions",
    path: "/premium-subscriptions",
    meta: premium_45subscriptionsyfN31OQqFbpo6ECMkvUJ7f1Ii4_txIFMVpfcbl7PwzAMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/premium-subscriptions.vue")
  },
  {
    name: "uspa-post-login-action",
    path: "/uspa-post-login-action",
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/uspa-post-login-action.js")
  },
  {
    name: indexF3iC03mNu_453D2_45r3s8aoR3QvprT_452nVtNUFQc9RX8toMeta?.name ?? "lms-contributors",
    path: "/lms/contributors",
    meta: indexF3iC03mNu_453D2_45r3s8aoR3QvprT_452nVtNUFQc9RX8toMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/contributors/index.vue")
  },
  {
    name: _91slug_93LJkZxizeHaI0BFHBVjg3_45Eu6luHZ7FEade2UdVTTQ_QMeta?.name ?? "lms-contributors-slug",
    path: "/lms/contributors/:slug()",
    meta: _91slug_93LJkZxizeHaI0BFHBVjg3_45Eu6luHZ7FEade2UdVTTQ_QMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/contributors/[slug].vue")
  },
  {
    name: _91slug_93C_kqXp3ZB6fJOT8_45odf3KoXCcY6mNCc7m1ZzLMeqJLAMeta?.name ?? "lms-blog-category-slug",
    path: "/lms/blog/category/:slug()",
    meta: _91slug_93C_kqXp3ZB6fJOT8_45odf3KoXCcY6mNCc7m1ZzLMeqJLAMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/blog/category/[slug].vue")
  },
  {
    name: _91bundleSlug_93WwCRvkXE2Cfv4COasEChjKlLNO7mpzljlfRpLM8aLF8Meta?.name ?? "lms-premium-bundleSlug",
    path: "/lms/premium/:bundleSlug()",
    meta: _91bundleSlug_93WwCRvkXE2Cfv4COasEChjKlLNO7mpzljlfRpLM8aLF8Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium/[bundleSlug].vue")
  },
  {
    name: "LmsPremiumBundlesForCourse",
    path: "/lms/premium/:courseSlug()",
    meta: _91courseSlug_93ISnCbgBMTKYCivZa4_45Pe4xdAGFHXGftl3R5BXY5bd0EMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium/[courseSlug].vue")
  },
  {
    name: "forms-contributor-contact",
    path: "/forms/contributor-contact",
    meta: contributor_45contact0APaV2HJUBBx6xbpEz4_45F9BDb83AyCP3mlpIJTnCp_IMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/forms/contributor-contact.vue")
  },
  {
    name: international_45polo_45academy_fHM75z_45SXIYyemNhIFD8TbntdO38DzVbl1P2rIZPBEMeta?.name ?? "international-polo-academy",
    path: "/international-polo-academy",
    meta: international_45polo_45academy_fHM75z_45SXIYyemNhIFD8TbntdO38DzVbl1P2rIZPBEMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/brands/ipa/pages/international-polo-academy.vue")
  },
  {
    name: indexZAp3hmlwzTwMhYhkEjAM3ekqct9cpuLRuWp6vJr68MEMeta?.name ?? "lms-course-categories",
    path: "/lms/course-categories",
    meta: indexZAp3hmlwzTwMhYhkEjAM3ekqct9cpuLRuWp6vJr68MEMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/course-categories/index.vue")
  },
  {
    name: _91slug_931T_54Gj23xMg_45q3VZ_45W_ZNDIv1oVpPDszuq0cv5X8ToMeta?.name ?? "lms-course-categories-slug",
    path: "/lms/course-categories/:slug()",
    meta: _91slug_931T_54Gj23xMg_45q3VZ_45W_ZNDIv1oVpPDszuq0cv5X8ToMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/course-categories/[slug].vue")
  },
  {
    name: index3VaL2gQB7HgnOw68nR77eVx8RVezxsMcTy1sYhp5w68Meta?.name ?? "lms-courses-courseSlug",
    path: "/lms/courses/:courseSlug()",
    meta: index3VaL2gQB7HgnOw68nR77eVx8RVezxsMcTy1sYhp5w68Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/courses/[courseSlug]/index.vue")
  },
  {
    name: _91_91videoSlug_93_93XhPDXXihl6WAywpryPCdN08aXngUv18E9t4RFwPyEyMMeta?.name ?? "lms-video-slug-videoSlug",
    path: "/lms/video/:slug()/:videoSlug?",
    meta: _91_91videoSlug_93_93XhPDXXihl6WAywpryPCdN08aXngUv18E9t4RFwPyEyMMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/video/[slug]/[[videoSlug]].vue")
  },
  {
    name: indexxJ0wVGI0Bsu41g12bHZDIpkfnOMVpn2B0pHKU_ZNYAwMeta?.name ?? "lms-premium-subscriptions",
    path: "/lms/premium-subscriptions",
    meta: indexxJ0wVGI0Bsu41g12bHZDIpkfnOMVpn2B0pHKU_ZNYAwMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium-subscriptions/index.vue")
  },
  {
    name: bundlesTy1LcUHXf9pd33y9S9u0Qp1SlmsG96j5JEK4y_45Es20cMeta?.name ?? "lms-courses-courseSlug-bundles",
    path: "/lms/courses/:courseSlug()/bundles",
    meta: bundlesTy1LcUHXf9pd33y9S9u0Qp1SlmsG96j5JEK4y_45Es20cMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/courses/[courseSlug]/bundles.vue")
  },
  {
    name: _91lessonSlug_93SGQ_OR5YyleMvxDn2wLkCBabaYBhtS_45_CTRg6wB9FM4Meta?.name ?? "lms-courses-courseSlug-lessonSlug",
    path: "/lms/courses/:courseSlug()/:lessonSlug()",
    meta: _91lessonSlug_93SGQ_OR5YyleMvxDn2wLkCBabaYBhtS_45_CTRg6wB9FM4Meta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/courses/[courseSlug]/[lessonSlug].vue")
  },
  {
    name: _91courseSlug_93_UXi1PvGUHM07QGcmylNOM2JlCkl_B3aChQKbZNMB7gMeta?.name ?? "lms-premium-subscriptions-courseSlug",
    path: "/lms/premium-subscriptions/:courseSlug()",
    meta: _91courseSlug_93_UXi1PvGUHM07QGcmylNOM2JlCkl_B3aChQKbZNMB7gMeta || {},
    component: () => import("C:/Users/Charl/Downloads/ipa-lms-live/pages/lms/premium-subscriptions/[courseSlug].vue")
  }
]